import React from 'react';
import ImageTab from '../../../../../components/ImageTab/ImageTab';

function ImagesEditTab({user, type, entity}) {

  return <ImageTab type={type} entity={entity} />
  
  }

  export default ImagesEditTab;